<template>
  <div
    v-if="memberPopupData && purchaseRecordData"
    class="member-status-popup"
    :class="`member-status-popup-${
      purchaseRecordData ? purchaseRecordData.state : 1
    }`"
  >
    <div v-if="memberPopupData.nav" class="member-icon-content">
      <img :src="memberPopupData.nav.title" alt="" />
    </div>
    <div class="status-wrapper">
      <div class="status-container">
        <div class="coupon-content">
          <div class="vip-countdown-wrapper">
            <template v-if="personInfo && personInfo.is_membership && !memberPopupData.isCountdown">
              <div class="user-info-wrapper">
                <div class="user-info-content">
                  <img
                    class="avatar"
                    :src="
                      personInfo.avatar_url ||
                      'https://files.wondercv.com/default_forum_icon.png'
                    "
                    alt=""
                  />
                  <div class="username">
                    {{ personInfo.name || personInfo.username }}
                  </div>
                </div>
                <div class="expire-time">{{ expiredTime }}</div>
              </div>
            </template>
            <template v-else>
              <img
                v-if="memberPopupData.image"
                :src="memberPopupData.image"
                class="vip-display-icon"
              />
              <div class="intro-content">
                <div>{{ memberPopupData.title }}</div>
                <div v-if="memberPopupData.subTitle" class="intro-sub-title">
                  {{ memberPopupData.subTitle }}
                </div>
              </div>
            </template>
            <Countdown
              v-if="memberPopupData.isCountdown"
              :start-time="purchaseRecordData && purchaseRecordData.order_time"
              :current-time="purchaseRecordData && purchaseRecordData.time_now"
              :duration="memberPopupData.duration"
              countdown-type="white"
            ></Countdown>
          </div>
          <div
            v-if="
              memberPopupData.couponList && memberPopupData.couponList.length
            "
            class="coupon-list"
          >
            <div
              v-for="(item, index) in memberPopupData.couponList"
              :key="index"
              class="coupon-item-content"
              :style="{ 'background-image': `url(${item.backgroundImage})` }"
            >
              <div class="coupon-left-content">
                ¥<span class="number">{{ item.money }}</span>
              </div>
              <div class="coupon-right-content">
                <span class="title">{{ item.couponTitle }}</span>
                <span class="desc">{{ item.couponDesc }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="vip-intro-container">
          <div class="intro-title">会员权益</div>
          <div class="desc-list-content">
            <div
              v-for="(item, index) in memberPopupData.introList"
              :key="index"
              class="list-item"
            >
              <template v-if="personInfo && personInfo.is_membership && !isMembershipExpired">
                <div class="intro-count">{{ renderEquityCount(item) }}</div>
                {{ item.memberName }}
              </template>
              <template v-else>
                <i :class="`iconfont ${item.icon}`"></i>
                {{ item.name }}
              </template>
            </div>
            <div class="list-item"></div>
          </div>
          <div v-if="memberPopupData.buttonInfo" class="popup-btn-content">
            <div class="more-text" @click="handleToMemberCenter">
              {{ memberPopupData.moreText }}
            </div>
            <div class="button-item" @click="handleToMemberCenter">
              <i :class="`iconfont ${memberPopupData.buttonInfo.icon}`"></i>
              {{ memberPopupData.buttonInfo.text }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import Countdown from "../Countdown";
import { PERMANENT_MEMBER, BUY_OUTSIDE, BUY_IN } from "@/assets/js/const";
import { routerTo, get_tUser } from "@/assets/js/util";
import api from "@/api";

const moment = require("moment");
export default {
  data() {
    return {
      BUY_IN,
      BUY_OUTSIDE,
      PERMANENT_MEMBER,
      equityCount: {
        cv_all_count: 0,
        cv_count: 0,
        cv_check_all_count: 0,
        cv_check_count: 0,
        cv_trans_all_count: 0,
        cv_trans_count: 0,
        find_error_all_count: 0,
        find_error_count: 0,
        id_photo_all_count: 0,
        id_photo_count: 0,
      },
    };
  },
  computed: {
    ...mapState("me", ["purchaseRecordData", "personInfo"]),
    ...mapGetters("me", ["memberPopupData"]),
    // 是会员，但是已经过期
    isMembershipExpired() {
      const { is_membership, membership_expired_at } = this.personInfo || {};
      return !is_membership && membership_expired_at;
    },
    expiredTime() {
      const { is_membership, membership_expired_at } = this.personInfo || {};
      if (is_membership && membership_expired_at.substr(0, 4) >= 2100) {
        return '你已经是超级简历终身会员啦～';
      } else if (this.isMembershipExpired) {
        return '您的会员已过期';
      }
      return `有效期至：${moment(membership_expired_at).format("YYYY-MM-DD")}`;
    },
  },
  components: {
    Countdown,
  },
  methods: {
    ...mapActions("me", ["getPurchaseRecordData"]),
    handleToMemberCenter() {
      routerTo("/account/users/buy_member", "_blank");
    },
    renderEquityCount(data) {
      const { totalCountField, countFiled } = data;
      if (this.equityCount[countFiled] === -1 || !countFiled) {
        return "∞";
      } else {
        return `${this.equityCount[countFiled]}/${this.equityCount[totalCountField]}`;
      }
    },
    async getAgreementCount() {
      try {
        let jwtInfo = get_tUser();
        const { code, data } = await api.account.getAgreementCount(jwtInfo.c_t);
        if (code === 1000) {
          this.equityCount = data;
        }
      } catch (error) {
        console.error(`fetch agreement count error ${error}`);
      }
    },
  },
  created() {
    if (!get_tUser().c_t) return;
    this.getAgreementCount();
    this.getPurchaseRecordData();
  },
};
</script>

<style lang="scss" scoped>
.member-status-popup {
  position: relative;
  height: 100%;
  margin-right: 16px;
  z-index: 2001;
  cursor: pointer;
  line-height: 1;
  .member-icon-content {
    display: flex;
    align-items: center;
    width: 69px;
    height: 100%;
    img {
      width: 69px;
      height: 26px;
      object-fit: cover;
      margin-bottom: 10px;
    }
  }
  .status-wrapper {
    display: none;
    position: absolute;
    top: 100%;
    right: -12px;
    padding-top: 8px;
    width: 390px;
    box-sizing: border-box;
    z-index: 1009;
    .status-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 390px;
      .coupon-content {
        width: 377px;
        padding: 15px 18px 1px;
        background: linear-gradient(to right, #fff5e6, #e8c7a5);
        box-shadow: 2px 5px 31px 0px rgba(46, 66, 104, 0.12);
        border-radius: 12px;
        box-sizing: border-box;
        .vip-countdown-wrapper {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 18px;
          font-weight: 600;
          color: #1d1f38;
          padding-bottom: 16px;
          .user-info-content {
            display: flex;
            align-items: center;
            .avatar {
              width: 32px;
              height: 32px;
              object-fit: cover;
              border-radius: 50%;
              margin-right: 12px;
            }
            .username {
              font-size: 18px;
              font-weight: 500;
              color: #1d1f38;
            }
          }
          .expire-time {
            font-size: 14px;
            line-height: 16px;
            color: #1d1f38;
            margin-top: 8px;
            font-weight: 400;
          }
        }
        .coupon-list {
          display: flex;
          align-items: center;
          .coupon-item-content {
            flex: 1;
            display: flex;
            align-items: center;
            height: 62px;
            background-image: url("https://logo.wondercv.com/banners/fDEcpXR0U9j3a1n.png");
            background-size: 100% 100%;
            background-repeat: no-repeat;
            &:not(:last-child) {
              margin-right: 11px;
            }
            .coupon-left-content {
              width: 96px;
              flex-shrink: 0;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 14px;
              line-height: 20px;
              font-weight: bold;
              color: #ff6837;
              margin: 19px 0;
              .number {
                font-size: 20px;
                letter-spacing: 1px;
                margin-bottom: 6px;
              }
            }
            .coupon-right-content {
              flex: 1;
              height: 100%;
              padding-left: 25px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              span {
                text-align: left;
              }
              .title {
                font-size: 14px;
                font-weight: 600;
                color: #1d1f38;
                margin-bottom: 8px;
              }
              .desc {
                font-size: 11px;
                font-weight: 400;
                color: rgba($color: #1d1f38, $alpha: 0.6);
              }
            }
          }
        }
      }
      .vip-intro-container {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 23px 0 30px;
        background: linear-gradient(to right, #414761, #1c1e37);
        border-radius: 12px;
        margin-top: -15px;
        z-index: 1;
        width: 100%;
        box-sizing: border-box;
        color: #fff;
        background-image: url("https://logo.wondercv.com/banners/Tk6GUv06rQTC7jX.png");
        background-size: cover;
        background-repeat: no-repeat;
        .intro-title {
          display: flex;
          align-items: center;
          text-shadow: 2px 5px 31px rgba(46, 66, 104, 0.12);
          margin-bottom: 2px;
          &::before,
          &::after {
            content: "";
            display: inline-block;
            width: 26px;
            height: 1px;
            background: linear-gradient(to left, #353b54 0%, #ffffff 100%);
          }
          &::after {
            background: linear-gradient(to right, #353b54 0%, #ffffff 100%);
            margin-left: 4px;
          }
          &::before {
            margin-right: 4px;
          }
        }
        .desc-list-content {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          .list-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 33%;
            margin-top: 22px;
            color: rgba($color: #fff, $alpha: 0.7);
            
            &:nth-child(3),
            &:nth-child(6) {
              margin-right: 0;
            }
            .iconfont,
            .intro-count {
              margin-bottom: 8px;
              color: #fff;
            }
          }
        }
        .popup-btn-content {
          display: flex;
          align-items: center;
          padding-top: 24px;
          width: 100%;
          padding-left: 32px;
          box-sizing: border-box;
          .more-text {
            font-size: 12px;
            color: rgba($color: #fff, $alpha: 0.7);
            text-decoration: underline;
            margin-right: 22px;
            &:hover {
              color: #fff;
            }
          }
          .button-item {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 180px;
            height: 40px;
            color: #1d1f38;
            background: linear-gradient(to right, #fff5e6, #e8c7a5);
            border-radius: 29px;
            font-weight: 600;
            .iconfont {
              color: #282c46;
              margin-right: 6px;
              font-weight: 400;
            }
            &:hover {
              background: linear-gradient(to right, #FFFFFF, #FFE6CD);;
            }
          }
        }
      }
    }
  }
  &:hover .status-wrapper {
    display: block;
  }
  &-1,
  &-7,
  &-3,
  &-6 {
    .status-wrapper {
      .status-container {
        .coupon-content {
          padding: 20px 20px 51px;
          .vip-countdown-wrapper {
            display: flex;
            justify-content: flex-start;
            text-align: left;
            padding-bottom: 0;
            .vip-display-icon {
              width: 42px;
              height: 42px;
              object-fit: cover;
              margin-right: 12px;
            }
            .intro-sub-title {
              font-size: 14px;
              font-weight: 400;
              color: #1d1f38;
              margin-top: 10px;
            }
          }
        }
        .vip-intro-container {
          margin-top: -51px;
        }
      }
    }
  }
}
</style>
